// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2022-12-30 19:52:05 +0100 (Fri, 30 Dec 2022) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 131481 $
//  Purpose   : support for OPR_Pagebox
// =============================================================================
export const dashpanels = true
